module.exports = __webpack_public_path__ + "static/media/prizm-field-poster.c06ee935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-field-poster.jpg
// module id = 3544
// module chunks = 0